export default {"src":"/_next/static/media/facebook.adcdb363.svg","height":21,"width":12,"blurWidth":0,"blurHeight":0};